<ng-container [appPreloader]="[endpoints.INCOME_SOURCE_TYPES_GET,
                               endpoints.INCOME_SOURCES_POST,
                               endpoints.INCOME_SOURCES_PUT,
                               endpoints.USER_PUT]"
  [preloaderType]="preloaderTypes.OVERLAY">
  @if (form) {
    <div class="ph-20">
      <div class="row g-0 m-15">
        <div class="col-12 col-lg-6">
          <div class="title align-v-center">
            <i class="icon icon-payed is-big ic-secondary"></i>
            <div class="ml-10">
              <h5>Salary and Wages</h5>
              <div class="mv-5">Let us know your PAYG Income details</div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <mat-radio-group id="onBoardingSalaryResidentSelect" [(ngModel)]="isAustralianResident"
            (ngModelChange)="onResidencyChanged()">
            <mat-radio-button [value]="true">Resident</mat-radio-button>
            <mat-radio-button [value]="false">Non-Resident</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      <div class="tabs">
        @if (!incomeSource.id) {
          <div
            id="onBoardingSalaryAdd"
            class="tab-add"
            (click)="addFormGroup()">
            <i class="fa fa-plus-circle"></i>
            Add Salary
          </div>
        }
        @for (group of form.controls; track group; let i = $index) {
          <div class="tab d-flex align-v-center"
            [class.active]="i === displayedFormIndex"
            (click)="selectForm(i)">
            <span [class.c-error]="group.invalid && group.touched">
              {{group.get('name').value || 'Employer ' + (i + 1)}}
            </span>
            @if (form.controls.length > 1) {
              <button
                appStopPropagation
                (click)="removeForm(i)"
                class="btn icon-close">
              </button>
            }
          </div>
        }
      </div>
      <form [formGroup]="form" appFormErrorScroll>
        @for (group of form.controls; track group; let i = $index) {
          @if (i === displayedFormIndex) {
            <ng-container [formGroup]="group">
              <div class="row">
                <ng-container formArrayName="salaryForecasts">
                  @for (salaryControl of group.get('salaryForecasts')['controls']; track salaryControl; let i = $index) {
                    <ng-container [formGroup]="salaryControl">
                      <div class="col-12 col-md-6">
                        <div class="salary-forecast">
                          <ng-container [appPreloader]="[endpoints.TAX_CALCULATION_POST]" [preloaderType]="preloaderTypes.OVERLAY">
                            <h6>Gross Amount</h6>
                            <div class="salary-forecast-value">
                              {{ salaryControl.get('grossAmount').value | customCurrency }}
                            </div>
                          </ng-container>
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="salary-forecast">
                          <ng-container [appPreloader]="[endpoints.TAX_CALCULATION_POST]" [preloaderType]="preloaderTypes.OVERLAY">
                            <h6>Net Amount</h6>
                            @if (!isNetAmountEdit) {
                              <div class="salary-forecast-value">
                                {{salaryControl.get('netPay').value | customCurrency}}
                              </div>
                            }
                            @if (isNetAmountEdit) {
                              <mat-form-field class="compact">
                                <input matInput type="number" formControlName="netPay">
                                @if (salaryControl.get('netPay').invalid) {
                                  <mat-error class="mt-20">
                                    <app-validation-error [errors]="salaryControl.get('netPay').errors"></app-validation-error>
                                  </mat-error>
                                }
                              </mat-form-field>
                            }
                            @if (!isNetAmountEdit) {
                              <button
                                (click)="startEditNetAmount()"
                                class="btn salary-forecast-edit-icon icon icon-edit">
                              </button>
                            }
                            @if (isNetAmountEdit) {
                              <button
                                (click)="finishEditNetAmount(salaryControl)"
                                class="btn salary-forecast-edit-icon icon icon-check">
                              </button>
                            }
                          </ng-container>
                        </div>
                        @if (isTaxCalculationLoading) {
                          <app-preloader [size]="30"></app-preloader>
                        }
                      </div>
                    </ng-container>
                  }
                </ng-container>
                <div class="col-12 col-md-6">
                  <mat-form-field id="onBoardingSalaryEmployerAdd">
                    <mat-label>Employer Name</mat-label>
                    <input matInput formControlName="name" placeholder="Enter Employer Name" required>
                    @if (group.get('name').invalid) {
                      <mat-error>
                        <app-validation-error [errors]="group.get('name').errors"></app-validation-error>
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <ng-container formArrayName="salaryForecasts">
                  @for (salaryControl of group.get('salaryForecasts')['controls']; track salaryControl; let i = $index) {
                    <ng-container [formGroup]="salaryControl">
                      <div class="col-12 col-md-6">
                        <app-currency-input min="0"
                          inputId="onBoardingSalaryAnnualInput"
                          formControlName="paygIncome"
                          label="Annual Salary"
                          placeholder="Enter Annual Amount">
                        </app-currency-input>
                      </div>
                      <div class="col-12 col-md-6">
                        <mat-form-field id="onBoardingSalaryPayFrequencySelect">
                          <mat-label>Pay Frequency</mat-label>
                          <mat-select formControlName="frequency" placeholder="Select Pay Frequency" required>
                            <mat-option [value]="paymentFrequencyTypes.WEEKLY">Weekly</mat-option>
                            <mat-option [value]="paymentFrequencyTypes.MONTHLY">Monthly</mat-option>
                            <mat-option [value]="paymentFrequencyTypes.FORTNIGHTLY">Fortnightly</mat-option>
                          </mat-select>
                          @if (salaryControl.get('frequency').invalid) {
                            <mat-error>
                              <app-validation-error [errors]="salaryControl.get('frequency').errors"></app-validation-error>
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      @if (isAustralianResident) {
                        <div class="col-12 col-md-6">
                          <mat-form-field id="onBoardingSalaryThresholdSelect">
                            <mat-label>Tax-Free Threshold</mat-label>
                            <mat-select formControlName="isTaxFree" placeholder="Select Threshold" required>
                              <mat-option [value]="true">Yes</mat-option>
                              <mat-option [value]="false">No</mat-option>
                            </mat-select>
                            @if (salaryControl.get('isTaxFree').invalid) {
                              <mat-error>
                                <app-validation-error [errors]="salaryControl.get('isTaxFree').errors"></app-validation-error>
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      }
                    </ng-container>
                  }
                </ng-container>
                <div class="col-12 col-md-6">
                  <app-datepicker id="onBoardingSalaryJobStartSelect"
                    formControlName="dateFrom"
                    placeholder="Start Date"
                    label="Job Start Date">
                  </app-datepicker>
                </div>
                <div class="col-12 col-md-6 align-v-center">
                  <mat-checkbox formControlName="isCurrent" matTooltip="Is this job current?">Current</mat-checkbox>
                </div>
                @if (!group.get('isCurrent').value) {
                  <div class="col-12 col-md-6">
                    <app-datepicker formControlName="dateTo"
                      placeholder="End Date"
                      label="Job End Date">
                    </app-datepicker>
                  </div>
                  <div class="col-12 col-md-6">
                    <mat-form-field>
                      <mat-label>Reason (*optional)</mat-label>
                      <input [maxlength]="100" matInput formControlName="closeReason" />
                      @if (group.get('closeReason').invalid) {
                        <mat-error>
                          <app-validation-error [errors]="form.get('closeReason').errors"></app-validation-error>
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
              </div>
            </ng-container>
          }
        }
      </form>
    </div>
  }
</ng-container>
